// extracted by mini-css-extract-plugin
export default {"content":"UseSkillAndEnemy_content__Q03So","title":"UseSkillAndEnemy_title__yukwq","subtitle":"UseSkillAndEnemy_subtitle__fGzof","select":"UseSkillAndEnemy_select__HIDQI"};